document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  var cartDrawer = qs('#CartDrawer');
  var mobileMenu = qs('#MobileMenuDrawer');
  var searchDrawer = qs('#SearchDrawer');

  qsa('[data-open-cart]').forEach(function (btn) { btn.addEventListener('click', function () { openDrawer(cartDrawer); }); });
  qsa('[data-open-mobile-menu]').forEach(function (btn) { btn.addEventListener('click', function () { openDrawer(mobileMenu); }); });
  qsa('[data-open-search]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(searchDrawer);
      var input = qs('.search-drawer__input', searchDrawer);
      if (input) setTimeout(function () { input.focus(); }, 150);
    });
  });
  qsa('[data-cart-drawer-close]').forEach(function (btn) { btn.addEventListener('click', function () { closeDrawer(cartDrawer); }); });
  qsa('[data-mobile-menu-close]').forEach(function (btn) { btn.addEventListener('click', function () { closeDrawer(mobileMenu); }); });
  var searchClose = qs('.search-drawer__close');
  if (searchClose) searchClose.addEventListener('click', function () { closeDrawer(searchDrawer); });
  qs('.mobile-drawer__overlay') && qs('.mobile-drawer__overlay').addEventListener('click', function () { closeDrawer(mobileMenu); });
  qs('.cart-drawer__overlay') && qs('.cart-drawer__overlay').addEventListener('click', function () { closeDrawer(cartDrawer); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(cartDrawer); closeDrawer(mobileMenu); closeDrawer(searchDrawer); }
  });

  /* ---------- Cart: AJAX add / update / remove ---------- */
function fetchCart() {
  return fetch('/cart.js', {
    cache: 'no-store'
  }).then(function (r) {
    return r.json();
  });
}

function updateCartCount(count) {
  qsa('.cart-count').forEach(function (el) {
    el.textContent = count;
  });
}

function bindCartDrawerEvents() {
  if (!cartDrawer) return;

  qsa('[data-cart-drawer-close]', cartDrawer).forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(cartDrawer);
    });
  });

  var overlay = qs('.cart-drawer__overlay', cartDrawer);

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeDrawer(cartDrawer);
    });
  }
}

function refreshCartDrawer() {
  return fetch(window.location.href, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    cache: 'no-store'
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newCartDrawer = doc.querySelector('#CartDrawer');

      if (newCartDrawer && cartDrawer) {
        cartDrawer.replaceWith(newCartDrawer);
        cartDrawer = newCartDrawer;

        bindCartDrawerEvents();
      }
    })
    .catch(function (err) {
      console.error('Cart drawer refresh failed', err);
    });
}

document.body.addEventListener('submit', function (e) {
  var form = e.target;

  if (!form.matches('.product-page__form')) return;

  e.preventDefault();

  var formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to add product to cart');
      }

      return response.json();
    })
    .then(function () {
      return Promise.all([
        refreshCartDrawer(),
        fetchCart()
      ]);
    })
    .then(function (results) {
      var cart = results[1];

      updateCartCount(cart.item_count);

      if (cartDrawer) {
        openDrawer(cartDrawer);
      }
    })
    .catch(function (err) {
      console.error('Add to cart failed', err);
    });
});
  /* Quantity steppers (cart drawer + cart page + product page) */
  document.body.addEventListener('click', function (e) {
    var decBtn = e.target.closest('[data-qty-decrease]');
    var incBtn = e.target.closest('[data-qty-increase]');
    if (!decBtn && !incBtn) return;
    var wrap = (decBtn || incBtn).closest('.qty-stepper, .cart-drawer__item-qty');
    if (!wrap) return;
    var input = qs('input[type="number"], .qty-value', wrap);
    if (!input) return;
    var isSpan = input.tagName.toLowerCase() === 'span';
    var current = parseInt(isSpan ? input.textContent : input.value, 10) || 1;
    var next = decBtn ? Math.max(0, current - 1) : current + 1;
    if (isSpan) { input.textContent = next; } else { input.value = next; }

    var lineKey = wrap.getAttribute('data-line-key');
    if (lineKey) {
      updateCartLine(lineKey, next);
    }
  });

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var subtotalEl = qs('#CartDrawerSubtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (quantity === 0) {
          var row = qs('[data-cart-item-key="' + key + '"]');
          if (row) row.remove();
        }
      })
      .catch(function (err) { console.error('Cart update failed', err); });
  }

  document.body.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-line-remove]');
    if (!removeBtn) return;
    updateCartLine(removeBtn.getAttribute('data-line-key'), 0);
  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR' });
  }


  /* ---------- Variant selection ---------- */
qsa('.product-page__form').forEach(function (form) {
  var optionGroups = qsa('.product-page__option-values', form);
  var variantInput = qs('input[name="id"]', form);
  var variantsJson = qs('.product-variants-json', form);

  if (!optionGroups.length || !variantInput || !variantsJson) return;

  var variants;

  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    console.error('Unable to read product variants');
    return;
  }

  function updateVariant() {
    var selectedOptions = optionGroups.map(function (group) {
      var selected = qs('.option-value.is-selected', group);
      return selected ? selected.getAttribute('data-value') : null;
    });

    var selectedVariant = variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });

    if (!selectedVariant) return;

    variantInput.value = selectedVariant.id;

    var addButton = qs('[name="add"]', form);

    if (addButton) {
      addButton.disabled = !selectedVariant.available;

      var text = qs('span', addButton);

      if (text) {
        text.textContent = selectedVariant.available
          ? 'Add to cart'
          : 'Sold out';
      }
    }
  }

  optionGroups.forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.option-value');

      if (!btn) return;

      qsa('.option-value', group).forEach(function (b) {
        b.classList.remove('is-selected');
      });

      btn.classList.add('is-selected');

      updateVariant();
    });
  });

  updateVariant();
});

  /* ---------- Product gallery swipe indicators ---------- */
  qsa('.product-page__gallery-track').forEach(function (track) {
    var indicators = qsa('.product-page__indicator', track.closest('.product-page__gallery'));
    if (indicators.length) indicators[0].classList.add('is-active');
    indicators.forEach(function (ind) {
      ind.addEventListener('click', function () {
        var idx = parseInt(ind.getAttribute('data-index'), 10);
        var slide = qsa('.product-page__slide', track)[idx];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      indicators.forEach(function (ind, i) { ind.classList.toggle('is-active', i === index); });
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = qs('[data-predictive-search] input[name="q"]');
  var resultsBox = qs('#PredictiveSearchResults');
  var searchTimer;
  if (searchInput && resultsBox) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      if (term.length < 2) { resultsBox.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { resultsBox.innerHTML = '<p>No results found.</p>'; return; }
            resultsBox.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" class="predictive-search-result">' + p.title + '</a>';
            }).join('');
          })
          .catch(function () {});
      }, 250);
    });
  }
});
